const initialState = {
  context_dictionary: {
    account_credit_def: '',
    lms_points: '',
    coop_def: '',
    gift_card_credit: ''
  },
  logo: {
    url: ''
  },
  secondary_image: {
    url: ''
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_PORTAL':
      return {
        ...action.payload
      }

    default:
      return state
  }
}
